import { Reducer, combineReducers } from 'redux'
import { CompanyState, CompanyActionTypes, Company } from './types'

// Type-safe initialState!
 const initialState: CompanyState = {
  errors: undefined,
  loading: false
}


// Thanks to Redux 4's much simpler typings, we can take away a lot of typings on the reducer side,
// everything will remain type-safe.

const ui: Reducer<CompanyState> = (state = initialState, action) => {
  switch (action.type) {
    
    case CompanyActionTypes.FETCH_REQUEST:{
      return { ...state, loading: true }
    }
    case CompanyActionTypes.FETCH_SUCCESS: {
      return { ...state, loading: false}
    }
    case CompanyActionTypes.FETCH_ERROR: {
      return { ...state, loading: false, errors: action.payload }
    }
    case CompanyActionTypes.CLEAR_SELECTED :{
      
      return { ...state, selected:undefined};
    }
    case CompanyActionTypes.SELECT_COMPANY :{
      return  { ...state, loading: true, selected:action.payload};
    }
    case CompanyActionTypes.SELECTED :{
      return  { ...state, loading: false};
    }
    default: {
      return state
    }
  }
}


const byId:Reducer<{}> = (state = {}, action) => {
  
  switch (action.type) {
    case CompanyActionTypes.FETCH_SUCCESS :{
      var _temp:any ={};
      action.payload.forEach( (item:Company)=> {
        _temp[item.id]= item;
      });
      return { ...state , ..._temp};
    }
    case CompanyActionTypes.ADD_SUCCESS :
      case CompanyActionTypes.EDIT_SUCCESS :{
      return {
        ...state , [action.payload.id]:action.payload
      }
    }
    default: {
      return state
    }
  }
}

const allIds:Reducer<number[]> = (state = [], action) => {
  switch (action.type) {
    case CompanyActionTypes.FETCH_SUCCESS :{
      
      return state.concat(...action.payload.map((item:Company) => item.id));
    }
    case CompanyActionTypes.ADD_SUCCESS :{
      return [
        ...state , action.payload.id
      ]
    }
    default: {
      return state
    }
  }
}

const selectedByIds:Reducer<number[]> = (state = [], action) => {
  switch (action.type) {
    case CompanyActionTypes.CLEAR_SELECTED :{
      
      return [];
    }
    case CompanyActionTypes.SELECTED :{
      return state.concat(action.payload.id)
    }
    default: {
      return state
    }
  }
}

const editingById:Reducer<{}> = (state = {}, action) => {
  switch (action.type) {
    case CompanyActionTypes.EDIT :{
      return { ...action.payload }
    }
    case CompanyActionTypes.EDIT_SUCCESS :{
      return {}
    }
    default: {
      return state
    }
  }
}

// Instead of using default export, we use named exports. That way we can group these exports
// inside the `index.js` folder.
const CompanyReducer = combineReducers({
  ui,
  byId,
  allIds,
  selectedByIds,
  editingById

})
export default CompanyReducer
